export const dispatchCustomEvent = (
  eventName: string,
  eventData?: object | string | undefined,
  target: EventTarget = window,
) => {
  const event = new CustomEvent(eventName, {
    detail: eventData,
    bubbles: true,
  });
  target.dispatchEvent(event);
};
